const ActiveDistricts = () => import("./main");

export default [
  {
    name: "active-districts",
    path: "/active-districts",
    component: ActiveDistricts
  }
];
